import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isDecimal', (values, value) => {
  if (!value || value === '') return true
  return /(^\d*\.?\d*[0-9]+\d*$)|(^[0-9]+\d*\.\d*$)/.test(value)
})
